import React, { useEffect, useState } from "react";
import { Box, Button, IconButton, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Header from "../../components/Header";
import CustomColumnMenu from "../../components/DataGridCustomColumnMenu";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { format } from "date-fns";
import { api, useGetCategoryQuery, useGetInterestQuery } from "../../state/api";
import { deleteInterestAction } from "../../redux/actions/interestAction";
import { usePostUpdateStatusMutation } from "../../state/api";
import { deleteCategory } from "../../redux/actions/categoryAction";

const Category = () => {
  const theme = useTheme();
  const { data: categoryData = {}, error, isLoading } = useGetCategoryQuery();
  const { data, Loading } = useGetInterestQuery();
  const [rowData, setRowData] = useState([]);
  const [rowDataInterest, setRowDataInterest] = useState([]);
  const [pageSize, setPageSize] = useState(20);
  const [pageSizeInterest, setPageSizeInterest] = useState(20);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (categoryData && categoryData.data) {
      setRowData(categoryData.data);
    }
  }, [categoryData]);

  useEffect(() => {
    if (data && data.data) {
      setRowDataInterest(data.data);
    }
  }, [data]);

  const handleEdit = async (categoryId) => {
    try {
      navigate(`/category/edit/${categoryId}`);
    } catch (error) {
      console.log("Error navigating to edit", error);
      toast.error("!Failed, Something went wrong ");
    }
  };

  const handleDelete = async (_id) => {
    try {
      const success = await dispatch(deleteCategory(_id));
      if (success) {
        toast.success("Category deleted successfully");
        dispatch(api.util.invalidateTags(["Category"]));
      } else {
        toast.error("Failed to delete category");
      }
    } catch (error) {
      console.error("Error Deleting Category", error);
    }
  };

  const navigateCreate = () => {
    navigate("/category/create");
  };

  const navigateInterest = () => {
    navigate("/category/interest");
  };

  const handleEditInterest = async (interestId) => {
    try {
      navigate(`/interest/edit/${interestId}`);
    } catch (error) {
      console.log("Error navigating to edit", error);
      toast.error("!Failed, Something went wrong ");
    }
  };

  const handleDeleteInterest = async (_id) => {
    try {
      const success = await dispatch(deleteInterestAction(_id));
      if (success) {
        toast.success("Interest deleted successfully");
        dispatch(api.util.invalidateTags(["Interest"]));
      } else {
        toast.error("Failed to delete Interest");
      }
    } catch (error) {
      console.error("Error deleting Intrest:", error);
    }
  };

  const [updateStatus] = usePostUpdateStatusMutation();

  const handleStatus = async (Id, isActive) => {
    const tag = "Interest";
    try {
      const response = await updateStatus({ Id, tag, isActive });
      // console.log(response);
      if (response.data.success) {
        setRowData((prevData) =>
          prevData.map((row) =>
            row._id === Id ? { ...row, isActive: !isActive } : row
          )
        );
        toast.success("Status updated successfully");
      } else {
        toast.error("Failed to update status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status");
    }
  };

  const removeInterest = (_id) => {
    Swal.fire({
      title: "Confirm Removal",
      text: "Are you sure you want to remove this ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeleteInterest(_id);
      }
    });
  };

  const removeCategory = (_id) => {
    Swal.fire({
      title: "Confirm Removal",
      text: "Are you sure you want to remove this ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(_id);
      }
    });
  };

  const columns = [
    {
      field: "title",
      headerName: "Category",
      flex: 0.5,
    },
    {
      field: "createdAt",
      headerName: "CreatedAt",
      flex: 0.5,
      renderCell: (params) => {
        const date = new Date(params.value);
        return format(date, "yyyy-MM-dd");
      },
    },
    {
      field: "updatedAt",
      headerName: "UpdatedAt",
      flex: 0.5,
      renderCell: (params) => {
        const date = new Date(params.value);
        return format(date, "yyyy-MM-dd");
      },
    },
    // {
    //   feild: "subCategory",
    //   headerName: "Sub Categoy",
    //   flex: 0.5,
    // },
    {
      field: "actions",
      headerName: "ACTIONS",
      flex: 0.6,
      renderCell: (params) => (
        <div>
          <IconButton
            // variant="contained"
            color="info"
            onClick={() => handleEdit(params.row._id)}
          >
            <EditIcon size="large" />
          </IconButton>
          <IconButton
            variant="contained"
            color="secondary"
            onClick={() => removeCategory(params.row._id)}
          >
            <DeleteIcon size="small" sx={{ color: "red" }} />
          </IconButton>
        </div>
      ),
    },
  ];

  const columns2 = [
    {
      field: "title",
      headerName: "Title",
      flex: 0.5,
    },
    {
      field: "isActive",
      headerName: "IsActive?",
      flex: 0.5,
      renderCell: (params) => (
        <div>
          <Switch
            checked={params.value}
            onChange={() => handleStatus(params.row._id, params.row.isActive)}
            inputProps={{ "aria-label": "toggle status" }}
            sx={{
              "& .MuiSwitch-switchBase.Mui-checked": {
                color: "green",
                "&:hover": {
                  backgroundColor: "rgba(0, 128, 0, 0.50)",
                },
              },
              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                backgroundColor: "green",
              },
              "& .MuiSwitch-switchBase": {
                color: "red",
                "&:hover": {
                  backgroundColor: "rgba(255, 0, 0, 0.5)",
                },
              },
              "& .MuiSwitch-switchBase + .MuiSwitch-track": {
                backgroundColor: "red",
              },
            }}
            color="default"
          />
          {params.value ? "T" : "F"}
        </div>
      ),
    },
    {
      field: "createdAt",
      headerName: "CreatedAt",
      flex: 0.5,
      renderCell: (params) => {
        const date = new Date(params.value);
        return format(date, "yyyy-MM-dd");
      },
    },
    {
      field: "updatedAt",
      headerName: "UpdatedAt",
      flex: 0.5,
      renderCell: (params) => {
        const date = new Date(params.value);
        return format(date, "yyyy-MM-dd");
      },
    },
    {
      field: "actions",
      headerName: "ACTIONS",
      flex: 0.6,
      renderCell: (params) => (
        <div>
          <IconButton
            variant="contained"
            color="info"
            onClick={() => handleEditInterest(params.row._id)}
          >
            <EditIcon size="large" />
          </IconButton>
          <IconButton
            variant="contained"
            color="secondary"
            onClick={() => removeInterest(params.row._id)}
          >
            <DeleteIcon size="small" sx={{ color: "red" }} />
          </IconButton>
        </div>
      ),
    },
  ];

  return (
    <Box m="1.5rem 2.5rem" display="flex" flexDirection="column">
      <ToastContainer />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap="1rem"
      >
        <Header title="CATEGORY / INTEREST MANAGEMENT" />
        <Box display="flex" gap="15px">
          <Button
            variant="contained"
            endIcon={<AddCircleIcon />}
            onClick={navigateInterest}
          >
            Add Interest
          </Button>
          <Button
            variant="contained"
            endIcon={<AddCircleIcon />}
            onClick={navigateCreate}
          >
            Add Category
          </Button>
        </Box>
      </Box>

      <Box
        m="1.5rem 2.5rem"
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
      >
        <Box
          width="49.5%"
          mt="40px"
          height="70vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: theme.palette.background.alt,
              color: theme.palette.secondary[100],
              borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: theme.palette.primary.success,
            },
            "& .MuiDataGrid-footerContainer": {
              backgroundColor: theme.palette.background.alt,
              color: theme.palette.secondary[100],
              borderTop: "none",
            },
            "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
              color: `${theme.palette.secondary[200]} !important`,
            },
          }}
        >
          <h3
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "green",
            }}
          >
            Category
          </h3>
          <DataGrid
            loading={isLoading || !rowData}
            getRowId={(row) => row._id}
            rows={rowData || []}
            columns={columns}
            pagination
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[10, 20, 50, 100]}
            components={{
              ColumnMenu: CustomColumnMenu,
            }}
          />
        </Box>

        <Box
          width="49.5%"
          mt="40px"
          height="70vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: theme.palette.background.alt,
              color: theme.palette.secondary[100],
              borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: theme.palette.primary.success,
            },
            "& .MuiDataGrid-footerContainer": {
              backgroundColor: theme.palette.background.alt,
              color: theme.palette.secondary[100],
              borderTop: "none",
            },
            "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
              color: `${theme.palette.secondary[200]} !important`,
            },
          }}
        >
          <h3
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "green",
            }}
          >
            Interest
          </h3>
          <DataGrid
            loading={Loading || !rowDataInterest}
            getRowId={(row) => row._id}
            rows={rowDataInterest || []}
            columns={columns2}
            pagination
            pageSize={pageSizeInterest}
            onPageSizeChange={(newPageSize) => setPageSizeInterest(newPageSize)}
            rowsPerPageOptions={[10, 20, 50, 100]}
            components={{
              ColumnMenu: CustomColumnMenu,
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
export default Category;
